var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 5,
    fill: "#F3F6F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4139_30986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1398 8.861C25.6299 8.35189 24.9388 8.06595 24.2183 8.06595C23.4977 8.06595 22.8066 8.35189 22.2968 8.861L10.0988 21.059C9.74945 21.4063 9.47248 21.8195 9.28388 22.2746C9.09529 22.7297 8.9988 23.2176 9.00001 23.7102V25.25C9.00001 25.4489 9.07903 25.6397 9.21968 25.7803C9.36033 25.921 9.5511 26 9.75001 26H11.2898C11.7823 26.0014 12.2703 25.9051 12.7254 25.7166C13.1805 25.5281 13.5937 25.2512 13.941 24.902L26.1398 12.7032C26.6486 12.1934 26.9344 11.5025 26.9344 10.7821C26.9344 10.0618 26.6486 9.37085 26.1398 8.861ZM12.8805 23.8415C12.4575 24.2617 11.886 24.4983 11.2898 24.5H10.5V23.7102C10.4993 23.4147 10.5571 23.1219 10.6703 22.8488C10.7834 22.5758 10.9496 22.3279 11.1593 22.1195L20.4165 12.8622L22.1415 14.5872L12.8805 23.8415ZM25.0785 11.6427L23.199 13.523L21.474 11.8017L23.3543 9.9215C23.4675 9.80848 23.6019 9.71887 23.7498 9.6578C23.8977 9.59673 24.0562 9.56539 24.2162 9.56556C24.3762 9.56574 24.5346 9.59742 24.6824 9.65882C24.8301 9.72021 24.9644 9.81011 25.0774 9.92337C25.1904 10.0366 25.28 10.1711 25.3411 10.3189C25.4021 10.4668 25.4335 10.6253 25.4333 10.7853C25.4331 10.9453 25.4015 11.1037 25.3401 11.2515C25.2787 11.3993 25.1888 11.5335 25.0755 11.6465L25.0785 11.6427Z",
    fill: "#28B446"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4139_30986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUser);
export default __webpack_public_path__ + "static/media/edit-user.9218705bac806fe802a54bf8a46b33ea.svg";
export { ForwardRef as ReactComponent };